export const CLEAR_ALL_RECENTS_ENABLED = 'api.profile.recents.clearAll.enabled';
